/**
 * Let's import the services/api
 * we made previously
 */
import chatApi from '../services/damos';
//const valgtArray = [];
/**
 * Constants
 */
export const POPULATE_MESSAGES_PENDING = 'POPULATE_MESSAGES_PENDING';
export const POPULATE_MESSAGES_SUCCESS = 'POPULATE_MESSAGES_SUCCESS';
export const POPULATE_MESSAGES_FAILED = 'POPULATE_MESSAGES_FAILED';
export const SUBMIT_MESSAGE_PENDING = 'SUBMIT_MESSAGE_PENDING';
export const SUBMIT_MESSAGE_SUCCESS = 'SUBMIT_MESSAGE_SUCCESS';
export const SUBMIT_MESSAGE_FAILED = 'SUBMIT_MESSAGE_FAILED';

export const UPDATE_CHOOSEN_ELEMENTS = 'UPDATE_CHOOSEN_ELEMENTS';

export const GET_FILTER_PENDING = 'GET_FILTER_PENDING';
export const GET_FILTER_SUCCESS = 'GET_FILTER_SUCCESS';
export const GET_FILTER_FAILED = 'GET_FILTER_FAILED';

export const GET_TABLE_PENDING = 'GET_TABLE_PENDING';
export const GET_TABLE_SUCCESS = 'GET_TABLE_SUCCESS';
export const GET_TABLE_FAILED = 'GET_TABLE_FAILED';

export const ITEM_HINT_DATA_PENDING = 'ITEM_HINT_DATA_PENDING';
export const ITEM_HINT_DATA_SUCCESS = 'ITEM_HINT_DATA_SUCCESS';
export const ITEM_HINT_DATA_FAILED = 'ITEM_HINT_DATA_FAILED';

export const GET_WORDSEARCH_SIMPLE_PENDING = 'GET_WORDSEARCH_SIMPLE_PENDING';
export const GET_WORDSEARCH_SIMPLE_SUCCESS = 'GET_WORDSEARCH_SIMPLE_SUCCESS';
export const GET_WORDSEARCH_SIMPLE_FAILED = 'GET_WORDSEARCH_SIMPLE_FAILED';


export const GET_WORDSEARCH_MULTIPLE_PENDING = 'GET_WORDSEARCH_MULTIPLE_PENDING';
export const GET_WORDSEARCH_MULTIPLE_SUCCESS = 'GET_WORDSEARCH_MULTIPLE_SUCCESS';
export const GET_WORDSEARCH_MULTIPLE_FAILED = 'GET_WORDSEARCH_MULTIPLE_FAILED';


export const GET_LEGENDS_PENDING = 'GET_LEGENDS_PENDING';
export const GET_LEGENDS_SUCCESS = 'GET_LEGENDS_SUCCESS';
export const GET_LEGENDS_FAILED = 'GET_LEGENDS_FAILED';


export const WORDSEARCH_RESET = 'WORDSEARCH_RESET';
export const SEARCH_TERM = 'SEARCH_TERM';
export const SHOW_ONLY_ACTIVE_TABLES = 'SHOW_ONLY_ACTIVE_TABLES';
export const SHOW_ONLY_ACTIVE_ENT = 'SHOW_ONLY_ACTIVE_ENT';
export const HIDE_TOOLTIP = 'HIDE_TOOLTIP';
/**
 * Actions - simple objects
 */


export const getSearchTerm = (e) => {
    return { type: SEARCH_TERM, searchTerm: e.target.value};
}
 export const wordsearchReset = () => {
    return { type: WORDSEARCH_RESET};
 }

 export const showOnlyActiveTables = () => {
   return { type: SHOW_ONLY_ACTIVE_TABLES};
 };

 export const showOnlyActiveEnt = (entity) => {
   return {type: SHOW_ONLY_ACTIVE_ENT, entity}
 }

 export const hidetooltip = () => {
    return {type: HIDE_TOOLTIP}
 }

function getItemHintDataPending(){
  return {
    type: ITEM_HINT_DATA_PENDING,
  };
}

function getItemHintDataSuccess(data){
  return {
    type: ITEM_HINT_DATA_SUCCESS,
    data
  };
}
function getItemHintDataFailed(){
  return {
    type: ITEM_HINT_DATA_FAILED,
  };
}

function populateMessagesPending() {
  return {
    type: POPULATE_MESSAGES_PENDING,
  };
}

function populateMessagesSuccess(messages) {

  return {
    type: POPULATE_MESSAGES_SUCCESS,
    messages
  };
}

function populateMessagesFailed(error) {
  return {
    type: POPULATE_MESSAGES_FAILED,
    error
  };
}

function submitMessagePending() {
  return {
    type: SUBMIT_MESSAGE_PENDING,
  };
}

function submitMessageSuccess() {
  return {
    type: SUBMIT_MESSAGE_SUCCESS,
  };
}

function submitMessageFailed(error) {
  return {
    type: SUBMIT_MESSAGE_FAILED,
    error
  };
}

function updateChoosenElements(eventChecked){
  return {
    type: UPDATE_CHOOSEN_ELEMENTS,
    eventChecked
  };
}
function getFilterPending() {
  return {
    type: GET_FILTER_PENDING,
  };
}
//messages,eventChecked, entValue, checked, id, valgtArray
function getFilterSuccess(messages, entity, eventChecked, eventValue, id) {
  return {
    type: GET_FILTER_SUCCESS,
    messages,
    entity,
    eventChecked,
    eventValue,
    id
  };
}

function getFilterFailed(error) {
  console.log(error)
  return {
    type: GET_FILTER_FAILED,
    error
  };
}


function getLegendsPending() {
  return {
    type: GET_LEGENDS_PENDING,
  };
}

function getLegendsSuccess(data) {
  return {
    type: GET_LEGENDS_SUCCESS,
    data
  };
}

function getLegendsFailed(error) {
  return {
    type: GET_LEGENDS_FAILED,
    error
  };
}

function getTablePending() {
  return {
    type: GET_TABLE_PENDING,
  };
}

function getTableSuccess(table) {
  return {
    type: GET_TABLE_SUCCESS,
    table
  };
}

function getTableFailed(error) {
  return {
    type: GET_TABLE_FAILED,
    error
  };
}


function wordsearchsimplePending() {
  return {
    type: GET_WORDSEARCH_SIMPLE_PENDING,
  };
}
function wordsearchsimpleSuccess(data) {
  return {
    type: GET_WORDSEARCH_SIMPLE_SUCCESS,
    data
  };
}
function wordsearchsimpleFailed(error) {
  return {
    type: GET_WORDSEARCH_SIMPLE_FAILED,
    error: error
  };
}



function wordsearchmultiplePending() {
  return {
    type: GET_WORDSEARCH_MULTIPLE_PENDING,
  };
}
function wordsearchmultipleSuccess(data) {
  return {
    type: GET_WORDSEARCH_MULTIPLE_SUCCESS,
    data
  };
}
function wordsearchmultipleFailed(error) {
  return {
    type: GET_WORDSEARCH_MULTIPLE_FAILED,
    error: error
  };
}


export function getLegends() {
  return (dispatch) => {
    dispatch(getLegendsPending());
    return chatApi.getlegend()
    .then((data) => dispatch(getLegendsSuccess(data)))
    .catch((error) => dispatch(getLegendsFailed(error.message)))
  }
}

export function getItemHintData(itemid) {
  return (dispatch) => {
    dispatch(getItemHintDataPending());
    return chatApi.itemhintdata(itemid)
    .then((data) => dispatch(getItemHintDataSuccess(data)))
    .catch((error) => dispatch(getItemHintDataFailed(error.message)))
  }
}


export function wordsearchsimple(formdata, filter) {
  return (dispatch) => {
    dispatch(wordsearchsimplePending());
    return chatApi.wordsearchsimple(formdata, filter)
    .then((data) => dispatch(wordsearchsimpleSuccess(data)))
    .catch((error) => dispatch(wordsearchsimpleFailed(error.message)))
  }
}

export function wordsearchmultiple(formdata, filter) {
  return (dispatch) => {
    dispatch(wordsearchmultiplePending());
    return chatApi.wordsearchmultiple(formdata, filter)
    .then((data) => dispatch(wordsearchmultipleSuccess(data)))
    .catch((error) => dispatch(wordsearchmultipleFailed(error.message)))
  }
}




export function getFilter(entity, entValue, event, id, choosenElements) {

      const eventChecked = entity
      const checked = event.target.checked

  return (dispatch) => {
    dispatch(getFilterPending());
    dispatch(updateChoosenElements(entValue));
    return chatApi.getFilter(entity, choosenElements)
    .then((messages) => dispatch(getFilterSuccess(messages,eventChecked, entValue, checked, id)))
    .catch((err) => dispatch(getFilterFailed(err)))
  }
}

export function getTable(tableid){
  return (dispatch) => {
    dispatch(getTablePending());
    return chatApi.getTable(tableid)
    .then((table) => dispatch(getTableSuccess(table)))
    .catch((err) => dispatch(getTableFailed(err)))
  }
}
/**
 * Action creators - able to dispatch any number of actions
 * The functions we export and make available for calling in components or elsewhere
 */
export function submitMessage({ name, text }) {
  return (dispatch) => {
    dispatch(submitMessagePending());

    /**
     * Here we use our API abstraction to
     * submit a message to the server
     */
    return chatApi.submitMessage({ name, text })
    .then(() => dispatch(submitMessageSuccess()))
    .catch((err) => dispatch(submitMessageFailed(err)))
  };
}

export function populateMessages() {
  return (dispatch) => {
    dispatch(populateMessagesPending());
    return chatApi.getMessages()
    .then((messages) => dispatch(populateMessagesSuccess(messages)))
    .catch((err) => dispatch(populateMessagesFailed(err)));
  };

}



// WEBPACK FOOTER //
// ./src/actions/index.js